import React, { useEffect, useState } from "react";
import { fetchTeamAssociates } from "../../../containers/actions/common/teamMemberAction";
import { FETCH_TEAM_ASSOCIATES_LOADING } from "../../../containers/actions/types";
import { useDispatch, useSelector } from "react-redux";
import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  Drawer,
  Grid,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import AddIcon from "@material-ui/icons/Add";
import InviteTeamMember from "./inviteTeamMember";
import ViewDetails from "../teamMembers/viewDetails";
const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 650,
  },
  active: {
    backgroundColor: "#2e7d32",
    color: "white",
    width: "6rem",
    padding: "5px 10px",
    borderRadius: "5px",
    textAlign: "center",
  },
  inactive: {
    backgroundColor: "#f44336",
    width: "6rem",
    color: "white",
    padding: "5px 10px",
    borderRadius: "5px",
    textAlign: "center",
  },
  searchField: {
    marginBottom: theme.spacing(2),
  },
  upload: {
    background: "#c8ddfb",
    color: "black",
    textTransform: "none",
    borderRadius: "2rem",
    // marginRight: 20,
    padding: "5px 20px",
    "&:hover": {
      backgroundColor: "#6495ED",
      color: "white",
    },
  },
  drawerPaper: {
    width: "30vw", // Set the drawer width here
  },
  multipleLogo: {
    border: "1px solid #7d7c7c",
    borderRadius: "4px",
    padding: "0.3rem",
    height: "inherit",
    marginLeft: "0.5rem",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "black",
      color: "white",
      border: "1px solid #FFF",
    },
  },
}));

const EditTeamMembers = ({
  teamMembersList,
  teamMembersListLoading,
  fetchDepartmentsList,
  departmentDetails,
  featuresAccess,
  selectedRole,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [inviteDrawer, setInviteDrawer] = useState(false);
  const [ViewDetailsDrawer, setViewDetailsDrawer] = useState(false);
  const [user, setUser] = useState({});

  const UserAvatar = ({ profileImage, profileName }) => {
    return (
      <Box display="flex" alignItems="center">
        <Avatar
          src={profileImage} // Use the Base64 string here
          alt={profileName} // Optional: Alt text for accessibility
          style={{ marginRight: "8px" }} // Adjust spacing if needed
        />
      </Box>
    );
  };
  const handleDetailView = (user) => {
    setUser(user);
    setViewDetailsDrawer(true);
    // fetchDepartmentsList
  };
  // const fetchDepartmentsList = [];
  const handleRefresh = () => { };
  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "flex-end",
          marginBottom: "2rem",
        }}
      >
        {(localStorage?.roleName === "Admin" &&
           (localStorage?.departmentId === "null" ||
           Number(localStorage?.getItem("departmentId")) === 1 )) 
          //  || Number(localStorage?.departmentId) === selectedRole?.departmentID
           &&
          featuresAccess?.addTeamMembers && (
            <Button
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              startIcon={<AddIcon />}
              onClick={() =>{ setInviteDrawer(true);
                sessionStorage.clear();
              }}
              // onClick={() => {
              //   setOpenUploadDSBatch(true);
              // }}
              className={classes.upload}
            >
              Add team member
            </Button>
          )}
        <Drawer
          anchor="right"
          open={inviteDrawer}
          onClose={() => setInviteDrawer(false)}
          classes={{ paper: classes.drawerPaper }}
        >
          {/* <CreateNewRole setOpen={setOpen} departmentAPI={departmentAPI} /> */}
          <InviteTeamMember
            setInviteDrawer={setInviteDrawer}
            departmentDetails={departmentDetails}
            handleRefresh={handleRefresh}
          />
        </Drawer>
      </div>
      <TableContainer
        component={Paper}
        style={{
          borderLeft: "1px solid #bdbdbd",
          borderRight: "1px solid #bdbdbd",
          borderBottom: "1px solid #bdbdbd",
        }}
      >
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>Team Member</TableCell>
              <TableCell>Phone</TableCell>
              <TableCell>Employee Number</TableCell>
              <TableCell>Department - Role</TableCell>
              <TableCell>Status</TableCell>
                  <TableCell>
                     {(localStorage?.roleName === "Admin" &&
                        (localStorage?.departmentId === "null" ||
                 Number(localStorage?.getItem("departmentId")) === 1 )) 
                          && (featuresAccess?.viewTeamMembers || featuresAccess?.addTeamMembers) && (
                   <> Action</>
                      )}
                    </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {teamMembersListLoading === true ? (
              <TableRow style={{ height: 150 }}>
                <TableCell colSpan={12}>
                  <div style={{ textAlign: "center" }}>
                    <CircularProgress color="primary" thickness={7} />
                  </div>
                </TableCell>
              </TableRow>
            ) : teamMembersList?.data?.length > 0 ? (
              teamMembersList?.data
                ?.filter((member) => member.account_status === "Active")
                .map((member, index) => (
                  <TableRow key={index}>
                    <TableCell
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "0.3rem",
                      }}
                    >
                      <Grid>
                        <UserAvatar profileImage={member?.profile_pic} />
                      </Grid>
                      <Grid
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                        }}
                      >
                        <Typography>{member?.full_name || "NA"}</Typography>
                        <Typography variant="body2" color="textSecondary">
                          {member?.email_address || "NA"}
                        </Typography>
                      </Grid>
                    </TableCell>
                    <TableCell>
                      {!member?.phone_number ||
                        member?.phone_number?.trim() === "" ||
                        member?.phone_number?.toLowerCase() === "null"
                        ? "NA"
                        : member.phone_number}
                    </TableCell>
                    <TableCell>{member?.employee_number || "NA"}</TableCell>
                    <TableCell>
                      {/* {member?.department_name || "NA"} */}
                      {`${member?.department_name || "NA"} - ${member?.roleName || "NA"
                        }`}
                      <br />
                      <Typography variant="body2" color="textSecondary">
                        {member?.access ? `${member.access} access` : "NA"}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <span
                        className={
                          member.account_status === "Active"
                            ? classes.active
                            : classes.inactive
                        }
                      >
                        {member?.account_status || "NA"}
                      </span>
                    </TableCell>
                    <TableCell>
                      {(localStorage?.roleName === "Admin" &&
                        (localStorage?.departmentId === "null" ||
                 Number(localStorage?.getItem("departmentId")) === 1 )) 
                //  || Number(localStorage?.departmentId) ===
                //           member?.department_id) 
                          &&
                        featuresAccess?.viewTeamMembers && (
                          <VisibilityIcon
                            fontSize="small"
                            className={classes.multipleLogo}
                            onClick={() => handleDetailView(member)}
                          />
                        )}
                    </TableCell>
                  </TableRow>
                ))
            ) : teamMembersList?.status === false ? (
              <TableRow
                style={{
                  border: "2px solid rgb(255,0,0)",
                  backgroundColor: "rgb(255,240,240)",
                  Opacity: 1,
                  textAlign: "center",
                  padding: "0.8rem",
                  fontSize: "0.875rem",
                }}
              >
                <TableCell colSpan={10} align="center">
                  'Something went wrong. Please contact Schrocken support.'
                </TableCell>
              </TableRow>
            ) : (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  No records found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <Drawer
        anchor="right"
        open={ViewDetailsDrawer}
        onClose={() => setViewDetailsDrawer(false)}
        classes={{ paper: classes.drawerPaper }}
      // hideBackdrop={true}
      >
        <ViewDetails
          user={user}
          departmentDetails={departmentDetails}
          setViewDetailsDrawer={setViewDetailsDrawer}
          handleRefresh={handleRefresh}
          selectedRole={selectedRole}
        />
      </Drawer>
    </div>
  );
};

export default EditTeamMembers;
